import ParameterErrors from '../errors/ParameterErrors';
import ParameterError from '../errors/ParameterError';
import getAbsolute from '../ui_core/getAbsolute';
import Alignment from '../ui_core/Alignment';
import './Tooltip.css';
const{throwNotProvided}=ParameterErrors;
export default class Tooltip {
	static register({element, text, delay, atomicCallbackShow, noEnterLeaveEvents}){
		if(delay===undefined)
			delay = 600;
		const tooltip = Tooltip._getOrCreateTooltip();
		let mouseDown = false;
		let cancelShow = null;
		const show = ()=>{
			cancelShow&&cancelShow();
			cancelShow = tooltip.show(element, text, delay, ()=>mouseDown);
		};
		const hide = ()=>{
			cancelShow&&cancelShow();
			tooltip.hide();
		};
		if(!noEnterLeaveEvents){
			element.addEventListener('mouseenter', show);
			element.addEventListener('mouseleave', hide);
		}
		const onMouseDown = ()=>{
			cancelShow&&cancelShow();
			mouseDown = true; 
			tooltip.hide();
		};
		const mouseUp = ()=>mouseDown = false;
		element.addEventListener('mousedown', onMouseDown);
		element.addEventListener('mouseup', mouseUp);
	const disposeMouseDown= ()=>{
			element.removeEventListener('mousedown', onMouseDown);
			element.addEventListener('mouseup', mouseUp);
		};
		const dispose = ()=>{
			element.removeEventListener('mouseenter', show);
			element.removeEventListener('mouseleave', hide);
			disposeMouseDown&&disposeMouseDown();
		};
		if(atomicCallbackShow){
			atomicCallbackShow.show = show;
		}
		return dispose;
	}
	static _getOrCreateTooltip(){
		if(Tooltip._tooltip)return Tooltip._tooltip;
		const element = document.createElement('div');
		element.classList.add('tooltip');
		const tooltipTextElement = document.createElement('div');
		tooltipTextElement.classList.add('tooltiptext');
		element.appendChild(tooltipTextElement);
		document.body.appendChild(element);
		const setVisible = Tooltip._getSetVisible(element);
		const setPosition = Tooltip._getSetPosition(element);
		const triangleElement = document.createElement('div');
		triangleElement.classList.add('triangle');
		element.appendChild(triangleElement);
		Tooltip._tooltip =  {
			element, 
			show:(elementShowingFor, text, delay, getMouseDown)=>{
				let showing = true;
				setTimeout(()=>{
					if(!showing||getMouseDown())return;
					tooltipTextElement.innerHTML = text;
					setVisible(true);
					setPosition(elementShowingFor);
				}, delay);
				const cancelShow = ()=>showing = false;
				return cancelShow;
			},
			hide:()=>{
				setVisible(false);
			},
			
		};
		return Tooltip._tooltip;
	}
	static _getSetVisible(element){
		return (visible)=>{
			if(visible){
				element.classList.add('visible');
				setTimeout(()=>element.classList.add('faded-in'),0);
			}
			else {
				element.classList.remove('visible');
				element.classList.remove('faded-in');
			}
		};
	}
	static _getSetPosition(element){
		const setAlignment = Tooltip._getSetAlignment(element);
		return (elementShowingFor)=>{
			element.style.left='0px';
			element.style.top='0px';
			const width = element.offsetWidth;
			const absolutePositionElementShowingFor = getAbsolute(elementShowingFor);
			const leftWhichWouldBeRequiredForLeftAlign = absolutePositionElementShowingFor.left- element.offsetWidth;
			let left;
			let alignment = Alignment.left;
			if(leftWhichWouldBeRequiredForLeftAlign<0){
				alignment = Alignment.right;
				const leftWhichWouldBeRequiredForRightAlign = absolutePositionElementShowingFor.left+ elementShowingFor.offsetWidth+element.offsetWidth;
				left = leftWhichWouldBeRequiredForRightAlign;
			}
			else{
				left = leftWhichWouldBeRequiredForLeftAlign;
			}
			setAlignment(alignment);
			element.style.left=String(left)+'px';
			element.style.top=String(absolutePositionElementShowingFor.top+ (elementShowingFor.offsetHeight/2) - (element.offsetHeight/2))+'px';
		};
	}
	static _getSetAlignment(element){
		let currentAlignmentClass = null;
		return (alignment)=>{
			const alignmentClass = alignment===Alignment.left?'align-left':'align-right';
			if(currentAlignmentClass===alignmentClass)return;
			element.classList.remove(currentAlignmentClass);
			element.classList.add(alignmentClass);
			currentAlignmentClass=alignmentClass;
		}
	}
}
